
  import { Vue, Component } from 'vue-property-decorator';
  import { State } from 'vuex-class';
  import { RootState } from '~/store';
  import { HeaderLayout } from '~/store/options';
  import Search from '~/components/header/search.vue';
  import NavPanel from '~/components/header/nav-panel.vue';
  import AppLink from '~/components/shared/app-link.vue';

  @Component({
    components: { AppLink, NavPanel, Search },
  })
  export default class Header extends Vue {
    @State((state: RootState) => state.options.headerLayout)
    layout!: HeaderLayout;
  }
